// Decides whether new chats on the Agents page run on Claude or on AMP agents.

import { useFlags } from "launchdarkly-react-client-sdk";

import { useLaunchDarklyReady } from "src/hooks/use-launch-darkly-ready";

/** The AMP agent type of a chat that the Agents page creates. */
export const AGENTS_CHAT_AGENT_TYPE = "agents_chat";

/**
 * Returns whether a new Agents page chat creates an AMP agent. The API
 * refuses to create AMP agents without piAgents, so both flags must be on.
 * isLoading stays true until LaunchDarkly initializes, because useFlags()
 * returns the default off value before then.
 */
export function useAgentsChatUsesAmpAgents(): {
  usesAmpAgents: boolean;
  isLoading: boolean;
} {
  const { agentsChatHarnessV2, piAgents } = useFlags();
  const isFlagReady = useLaunchDarklyReady();
  return {
    usesAmpAgents: Boolean(agentsChatHarnessV2 && piAgents),
    isLoading: !isFlagReady,
  };
}
